import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { siteConfig } from '../../data/config';
import { useEditorPreview } from '../../contexts/EditorContext';
import { Pending } from '../Pending';
export function Guarantee() {
  const editor = useEditorPreview();
  const g = siteConfig.guarantee;
  const ready = Boolean(g.days && g.headline && g.terms);
  if (!ready && !editor) return null;
  return <section className="bg-white px-5 py-5" data-id="element-61" data-mp="2ebyf4d06b35s">
      <div className="mx-auto flex max-w-[520px] gap-3 rounded-[3px] border border-line bg-white px-4 py-3 shadow-[0_1px_4px_rgba(16,24,32,0.08)]" data-id="element-62" data-mp="2ef44ltcps721">
        <ShieldCheckIcon className="h-5 w-5 shrink-0 text-navy" aria-hidden="true" data-id="element-63" data-mp="2oaxqw4g8jex0" />
        <div data-id="element-64" data-mp="2sdavuqn5r8sq">
          <h2 className="font-display text-[14px] uppercase leading-tight text-navy" data-id="element-65" data-mp="2sd2f2nnwzjc9">
            {g.headline || 'Your purchase guarantee'} {!ready && <Pending label="Guarantee" className="ml-1 align-middle" data-id="element-66" data-mp="tz981r6vus7c" />}
          </h2>
          <p className="mt-1 text-[11px] leading-[1.55] text-muted" data-id="element-67" data-mp="xz9v2081sbq0">
            {g.terms || 'Add the guarantee period and conditions in the configuration. This block stays hidden on the published page until the terms are provided.'}
          </p>
        </div>
      </div>
    </section>;
}